export default "__VITE_ASSET__BvSPWCQi__"